import { clientInfo } from 'configureBrand'
import { getCookie } from './cookieHelpers'

const { clientName } = clientInfo

export type SupportedLanguage = 'en' | 'es'

export default (): SupportedLanguage => {
  const availableLanguages: SupportedLanguage[] = ['en', 'es']
  const languageFromCookie = getCookie(
    `language-${clientName}`
  ) as SupportedLanguage
  if (availableLanguages.includes(languageFromCookie)) {
    return languageFromCookie
  }
  return 'en'
}
